import arrowOutwardWhite from "@/assets/images/user/arrowOutwardWhite.svg";
import icAward1 from "@/assets/images/user/icAward1.svg";
import icAward2 from "@/assets/images/user/icAward2.svg";
import icAward3 from "@/assets/images/user/icAward3.svg";
import icAward4 from "@/assets/images/user/icAward4.svg";
import icAward5 from "@/assets/images/user/icAward5.svg";
import soundtrack2024Img1 from "@/assets/images/user/soundtrack2024Img1.png";
import soundtrack2024Img2 from "@/assets/images/user/soundtrack2024Img2.png";
import soundtrack2024Img3 from "@/assets/images/user/soundtrack2024Img3.png";
import soundtrack2024Img4 from "@/assets/images/user/soundtrack2024Img4.png";
import soundtrack2024Img5 from "@/assets/images/user/soundtrack2024Img5.png";
import soundtrack2024Img6 from "@/assets/images/user/soundtrack2024Img6.png";
import soundtrack2024Img7 from "@/assets/images/user/soundtrack2024Img7.png";
import soundtrack2024Img8 from "@/assets/images/user/soundtrack2024Img8.png";
import soundtrack2024Img9 from "@/assets/images/user/soundtrack2024Img9.png";
import soundtrack2024Img10 from "@/assets/images/user/soundtrack2024Img10.png";
import soundtrackPoster from "@/assets/images/user/soundtrackPoster.jpg";
import soundtrackTxtImg from "@/assets/images/user/soundtrackTxtImg.svg";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";

const awardList = [
    {
        award: "대상",
        title: "리프(Lif)",
        link: "https://youtu.be/C3TfBABAizg?si=jAD7hSmTP99BWd3v",
        img: soundtrack2024Img1,
    },
    {
        award: "금상",
        title: "Run into Galaxy",
        link: "https://youtu.be/DD1DcUwKENs?si=mBrd2x8CgZVjcXQE",
        img: soundtrack2024Img2,
    },
    {
        award: "은상",
        title: "Keepro & SUZNN",
        link: "https://youtu.be/APSkOoqaRSI?si=genyWwMtJCtxJklj",
        img: soundtrack2024Img3,
    },
    {
        award: "은상",
        title: "e-dust",
        link: "https://youtu.be/4OY8plZQ1Dk?si=MhRglkFGLLHwbmb9",
        img: soundtrack2024Img4,
    },
    {
        award: "동상",
        title: "데마시아",
        link: "https://youtu.be/lmxXpwkCsMo?si=AkacKxwTfgdZV0By",
        img: soundtrack2024Img5,
    },
    {
        award: "동상",
        title: "목화",
        link: "https://youtu.be/kKWkd1PLbeE?si=IoOmJ5_-GYzyElnl",
        img: soundtrack2024Img6,
    },
    {
        award: "본상",
        title: "dizzy",
        link: "https://youtu.be/_sJZjpW8LSQ?si=jdt4F9G39ueeEFnF",
        img: soundtrack2024Img7,
    },
    {
        award: "본상",
        title: "DPS",
        link: "https://youtu.be/GBJ7XsMeScU?si=W5WE-NbVv6To8YkT",
        img: soundtrack2024Img8,
    },
    {
        award: "본상",
        title: "Unknown Tree",
        link: "https://youtu.be/Pdew8ZPjyi0?si=YpF3ZRSqb3Zm1PZB",
        img: soundtrack2024Img9,
    },
    {
        award: "본상",
        title: "백안",
        link: "https://youtu.be/b4NFUkbfeRE?si=dgXzIQCKSZF_bqtH",
        img: soundtrack2024Img10,
    },
];

export default function SoundTrack() {
    return (
        <div className="px-[20px] xl:px-0">
            <section className="max-w-[1400px] w-full mx-auto pb-[60px] md:pb-[80px]">
                <TitleBox
                    title="SOUND TRACK"
                    text={
                        <div className="text-[28px] md:text-[40px] md:flex md:items-center md:justify-center xl:text-[60px]">
                            <p className="flex items-start justify-center">
                                <span>The 1</span>
                                <span className="text-[18px] md:text-[24px] xl:text-[40px]">st&nbsp;</span>
                                <span>GXG&nbsp;</span>
                            </p>
                            <span>SOUND TRACK</span>
                        </div>
                    }
                />
                <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                    <div>
                        <img src={soundtrackPoster} alt="soundtrack" />
                    </div>
                    <div className="pt-[40px] w-full xl:pt-0 xl:flex-1 xl:flex xl:flex-col xl:justify-between">
                        <div className="hidden md:block">
                            <img src={soundtrackTxtImg} alt="soundtrack" />
                        </div>
                        <ul className="flex flex-col gap-[12px] md:gap-[16px] md:pt-[40px] xl:pt-0">
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[76px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    프로그램
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    GXG 2024 게임음악 경연대회
                                    <br /> The 1st GXG SOUND TRACK
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[76px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    모집기간
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    2024년 6월 7일(금)~7월 21일(일)
                                </p>
                            </li>
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[76px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    경연주제
                                </p>
                                <div className="flex-1 flex flex-col gap-[8px]">
                                    <p className="text-[16px] font-medium text-black font-['GongGothicLight'] leading-[1.8] md:text-[20px] md:py-[6px]">
                                        10개 게임사 참여, <br className="md:hidden" />총 12개의 모티브 게임
                                    </p>
                                    <div className="bg-white p-[8px] text-[14px] font-['GongGothicLight'] leading-[1.8] w-[calc(100%+88px)] -ml-[88px] text-black md:w-full md:ml-0 md:text-[20px] md:p-[16px]">
                                        가디언 테일즈, 검은사막, 던전앤파이터 모바일, <br className="xl:hidden" />
                                        로스트아크, 리그오브레전드, 리니지, 메이플스토리, <br className="xl:hidden" />
                                        모바일 한게임 신맞고, <br className="hidden xl:block" />
                                        모바일 한게임 포커, 에픽세븐, <br className="xl:hidden" />
                                        PUBG: 배틀그라운드, P의 거짓
                                    </div>
                                </div>
                            </li>
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[76px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    시상부문
                                </p>
                                <div className="flex-1 flex flex-col gap-[8px]">
                                    <p className="text-[16px] font-medium text-black font-['GongGothicLight'] leading-[1.8] md:text-[20px] md:py-[6px]">
                                        시상 부문 5개(10팀) / <br className="md:hidden" />
                                        총상금 2,300만원
                                    </p>
                                    <ul className="bg-white p-[8px] leading-[1.5] w-[calc(100%+88px)] -ml-[88px] text-black flex flex-col gap-[8px] md:w-full md:ml-0 md:p-[16px] md:[&>li>p]:text-[20px] md:flex-wrap md:gap-x-[10px] md:gap-y-[8px] md:flex-row">
                                        <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                            <img src={icAward1} alt="대상" />
                                            <p className="font-['GongGothicMedium'] text-[18px]">대상</p>
                                            <p className="font-['GongGothicLight']">1,000만원(1팀)</p>
                                        </li>
                                        <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                            <img src={icAward2} alt="금상" />
                                            <p className="font-['GongGothicMedium'] text-[18px]">금상</p>
                                            <p className="font-['GongGothicLight']">500만원(1팀)</p>
                                        </li>
                                        <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                            <img src={icAward3} alt="은상" />
                                            <p className="font-['GongGothicMedium'] text-[18px]">은상</p>
                                            <p className="font-['GongGothicLight']">200만원(2팀)</p>
                                        </li>
                                        <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                            <img src={icAward4} alt="동상" />
                                            <p className="font-['GongGothicMedium'] text-[18px]">동상</p>
                                            <p className="font-['GongGothicLight']">100만원(2팀)</p>
                                        </li>
                                        <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                            <img src={icAward5} alt="본상" />
                                            <p className="font-['GongGothicMedium'] text-[18px]">본상</p>
                                            <p className="font-['GongGothicLight']">50만원(4팀)</p>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[120px] md:pb-[160px]">
                <SubTitle title="경연대회 본선 무대 (2024)" className="pb-[24px] md:pb-[40px]" />
                <ul className="flex flex-col gap-[40px] md:flex-row md:flex-wrap md:gap-[40px] xl:gap-x-[20px] xl:gap-y-[40px]">
                    {awardList.map((item, i) => (
                        <li
                            key={`img_${i}`}
                            className={`w-full ${i > 1 ? "md:w-[calc(50%-20px)] xl:w-[calc(25%-15px)]" : "xl:w-[calc(50%-10px)]"}`}
                        >
                            <div className="cursor-pointer">
                                <div className="relative w-full aspect-video group">
                                    <div className="absolute inset-0 z-[2] transition-all duration-500 rounded-[20px_0_20px_0] after:content-[''] after:absolute after:inset-0 after:bg-[linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] after:opacity-0 after:transition-all after:duration-500 after:z-[1] after:rounded-[20px_0_20px_0] group-hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] group-hover:after:opacity-100 group-hover:p-[4px]">
                                        <div className="w-full h-full overflow-hidden rounded-[20px_0_20px_0] z-[2] relative">
                                            <a
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="block relative after:content-[''] after:absolute after:inset-0 after:bg-[rgba(0,0,0,0.4)] after:opacity-0 after:transition-all after:duration-500 after:z-[1] hover:after:opacity-100"
                                            >
                                                <img
                                                    src={item.img}
                                                    alt={item.title}
                                                    className="w-full h-full object-cover transition-all duration-500 xl:group-hover:scale-[1.2]"
                                                />
                                                <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center gap-[12px] text-[24px] font-['GongGothicMedium'] text-white opacity-0 group-hover:opacity-100 transition-all duration-500 z-[2]">
                                                    다시보기
                                                    <img src={arrowOutwardWhite} alt="다시보기" />
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center gap-[16px] pt-[16px]">
                                    <div className="max-w-[72px] w-full text-[20px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:t>xt-[20px] md:py-[4px]">
                                        <p
                                            style={{
                                                background: `${item.award === "대상" ? "linear-gradient(180deg, #EB0771 0%, #850440 100%)" : item.award === "금상" ? "linear-gradient(180deg, #EB8E03 0%, #855002 100%)" : item.award === "은상" ? "linear-gradient(180deg, #9C8E8E 0%, #363131 100%)" : item.award === "동상" ? "linear-gradient(180deg, #654F42 0%, #CB9E84 100%)" : "black"}`,
                                                backgroundClip: "text",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                            }}
                                        >
                                            {item.award}
                                        </p>
                                    </div>
                                    <p className="text-[20px] font-['GongGothicLight']">{item.title}</p>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
}
